var l = /* @__PURE__ */ ((e) => (e.medium = "medium", e.large = "large", e))(l || {}), i = /* @__PURE__ */ ((e) => (e.column = "column", e.row = "row", e))(i || {});
const o = Symbol("radio"), t = (e) => {
  switch (e) {
    case "medium":
      return "radio-md";
    case "large":
      return "radio-lg";
    default:
      return "";
  }
}, m = (e, r) => {
  const a = t(
    e.size || r.size || "medium"
    /* medium */
  ), s = r.disabled || e.disabled ? "radio-disabled" : "", d = r.error || e.error ? "radio-alert" : "";
  return `radio radio-primary ${a} ${s} ${d}`;
};
export {
  i as RadioGroupDirection,
  l as RadioSize,
  o as RadioSymbol,
  m as getRadioStyleClasses
};
